import React from 'react';

import { getHumanReadableCount } from '@lyearn/core/utils/number/getHumanReadableCount';
import { useTranslation } from '@lyearn/i18n';
import { Typography } from '@lyearn/ui';
import DisplayCard from '@/modules/content/components/ContentCard/DisplayCard';
import { ContentCardTypeEnum } from '@/modules/content/config/cards';

import { useAdaptEvent } from '../../config';
import { EventCardProps } from '../types';

function EventCardDisplay(props: EventCardProps & { useLegacyDefaultCard?: boolean }) {
  const { t } = useTranslation();
  const { className, accessories, imageProps, isNewHomepage, useLegacyDefaultCard, noDescription } =
    props;
  const event = useAdaptEvent(props.event, ContentCardTypeEnum.Display);

  const usersCount = React.useMemo(
    () => getHumanReadableCount(props.event?.usersCount),
    [props.event?.usersCount],
  );

  return (
    <DisplayCard
      accessories={accessories}
      baseContent={event}
      className={className}
      footer={
        isNewHomepage ? null : (
          <Typography color="text-text-secondary" variant="body-short-02">
            {t('Events:Attendance', { usersCount })}
          </Typography>
        )
      }
      imageProps={imageProps}
      isDiscoverPage={useLegacyDefaultCard}
      isNewHomepage={isNewHomepage}
      noDescription={noDescription}
    />
  );
}

export default EventCardDisplay;
